const mainDomain = "https://core.agriquiz.in/";
const imageDomain = "https://core.agriquiz.in";

// const mainDomain = "http://localhost:5001/";
// const imageDomain = "http://localhost:5001";

const Constants = {
  imageDomain,
  getUrls: {
    getAllSubjects: mainDomain + "subject/list-dash",
    getAllExams: mainDomain + "exam/list-dash",
    getAllExamLists: mainDomain + "api/v2/admin/pyq/exam-lists/list-dash",
    getAllExamListSets: mainDomain + "api/v2/admin/pyq/exam-list-sets/list-dash",
    getAllYears: mainDomain + "year/list-dash",
    getAllTopics: mainDomain + "topic/list-dash",
    getAllLevels: mainDomain + "level/list-dash",
    getAllArLevels: mainDomain + "ar-level/list-dash",
    getAllQuestions: mainDomain + "question/list-dash",
    getAllArQuestions: mainDomain + "ar-questions/list-dash",
    getSingleArQuestion: mainDomain + "ar-questions/list-dash/",
    getAllAgriBoosts: mainDomain + "api/v2/admin/agriboost/list-dash",
    getSingleAgriBoost: mainDomain + "api/v2/admin/agriboost/list-dash/",
    getAgriBoostMetaSubjects: mainDomain + "api/v2/admin/agriboost/meta/subjects",
    getAgriBoostMetaTopics: mainDomain + "api/v2/admin/agriboost/meta/topics",
    getAllPreviousYearQuestions: mainDomain + "api/v2/admin/pyq/previous-year-questions/list-dash",
    getAllPreviousYearDocuments: mainDomain + "api/v2/admin/pyq/previous-year-documents/list-dash",
    getPyqMetaExams: mainDomain + "api/v2/admin/pyq/meta/exams",
    getPyqMetaYears: mainDomain + "api/v2/admin/pyq/meta/years",
    getPyqMetaSubjects: mainDomain + "api/v2/admin/pyq/meta/subjects",
    getPyqMetaTopics: mainDomain + "api/v2/admin/pyq/meta/topics",
    getPyqMetaExamLists: mainDomain + "api/v2/admin/pyq/meta/exam-lists",
    getAllUsersList: mainDomain + "users/list-dash",
    getUserDetails: mainDomain + "users/details-dash/",
    getUserFeedback: mainDomain + "users/details-dash/",
    getUserPracticeAttempt: mainDomain + "users/details-dash/",
    getUserAiInsights: mainDomain + "users/details-dash/",
    getUserAttemptReports: mainDomain + "users/attempt-reports-dash",
    getAllUniversities: mainDomain + "universities/list-dash",
    getSingleUniversity: mainDomain + "universities/list-dash/",
    getAllEmployees: mainDomain + "employees/list-dash",
    getSingleEmployee: mainDomain + "employees/list-dash/",
    getAllTestSeries: mainDomain + "testseries/list-dash",
    getSingleTestSeries: mainDomain + "testseries/single/",
    getTestSeriesLeaderboard: mainDomain + "testseries/leaderboard/",
    getAllLiveTests: mainDomain + "live-tests/list-dash",
    getSingleLiveTest: mainDomain + "live-tests/single/",
    getLiveTestLeaderboard: mainDomain + "live-tests/leaderboard/",
    getLiveTestQuestions: mainDomain + "live-tests/questions/",
    suggestedQuestions: mainDomain + "testseries/suggest-questions",
    getMockTestSeriesQuestions: mainDomain + "testseries/mock-questions/",

    getDashboard: mainDomain + "dashboard/my-dash",
    getAdminDasboard: mainDomain + "dashboard/admin-dash",
    getAdminActiveUsers: mainDomain + "dashboard/admin-dash/active-users",
    getMostActiveUsers: mainDomain + "dashboard/admin-dash/most-active-users",
    getAdminMonthlyAnalytics: mainDomain + "dashboard/admin-dash/monthly-analytics",
    getFeatureAnalytics: mainDomain + "dashboard/feature-analytics",
    getFriendsTestReports: mainDomain + "dashboard/friends-test-reports",
    getFriendsTestInvites: mainDomain + "dashboard/friends-test-reports/",
    getLearningAttemptReports: mainDomain + "dashboard/learning-attempt-reports",
    getAppRuntimeSettings: mainDomain + "dashboard/settings/runtime",
    getWalletWithdrawals: mainDomain + "dashboard/wallet-withdrawals/list-dash",
    getTransactions: mainDomain + "dashboard/transactions",
    getSubscriptionPlans: mainDomain + "api/v2/admin/subscription-plans",
    getSubscriptionSettings: mainDomain + "api/v2/admin/subscription-settings",
    getUserSubscription: mainDomain + "api/v2/admin/users/",
    getOverallPurchaseOffers: mainDomain + "api/v2/admin/purchase-offers/overall",
    getUserPurchaseOffers: mainDomain + "api/v2/admin/users/",
    getAllTestimonials: mainDomain + "testimonial",
    getAllPopup: mainDomain + "popup",
    getAllJobApplications: mainDomain + "applyCareer",
    getAllContacts: mainDomain + "contacts",
    getAllBlogs: mainDomain + "blogs/list-dash",
    getAllNews: mainDomain + "news/list-dash",
    getSingleNews: mainDomain + "news/list-dash/",
    getAllGallery: mainDomain + "gallery/list-dash",
    getSingleGallery: mainDomain + "gallery/list-dash/",
    getAllWebContacts: mainDomain + "web-contact/list-dash",
    getAllSupportIssues: mainDomain + "web-contact/support/tickets/list-dash",
    getSupportTicketDetails: mainDomain + "web-contact/support/tickets/list-dash/",
    getAllNotifications: mainDomain + "notifications/list",
    getDksCarsBhataparaRegistrations:
      mainDomain + "event-registrations/dkscarsbhatapra/list-dash",
  },
  postUrls: {
    sendSupportTicketMessage: mainDomain + "web-contact/support/tickets/list-dash/",
    createUserFeedback: mainDomain + "users/details-dash/",
    createSubject: mainDomain + "subject/create",
    createExam: mainDomain + "exam/create",
    createExamList: mainDomain + "api/v2/admin/pyq/exam-lists/create",
    createExamListSet: mainDomain + "api/v2/admin/pyq/exam-list-sets/create",
    autoCreateExamListSets: mainDomain + "api/v2/admin/pyq/exam-list-sets/auto-create",
    createYear: mainDomain + "year/create",
    createTopic: mainDomain + "topic/create",
    createLevel: mainDomain + "level/create",
    createArLevel: mainDomain + "ar-level/create",
    createQuestion: mainDomain + "question/create",
    createArBulkImport: mainDomain + "ar-questions/bulk-import",
    createAgriBoost: mainDomain + "api/v2/admin/agriboost/create",
    createAgriBoostBulkImport: mainDomain + "api/v2/admin/agriboost/bulk-import",
    createPreviousYearQuestion: mainDomain + "api/v2/admin/pyq/previous-year-questions/create",
    createPreviousYearBulkImport:
      mainDomain + "api/v2/admin/pyq/previous-year-questions/bulk-import",
    createPreviousYearDocument: mainDomain + "api/v2/admin/pyq/previous-year-documents/create",
    createUniversity: mainDomain + "universities/create",
    createEmployee: mainDomain + "employees/add-new",
    creatBulkImport: mainDomain + "question/bulk-import",
    generateAIQuestions: mainDomain + "question/generate-ai",
    createTestSerikes: mainDomain + "testseries/create",
    createMockTestSeries: mainDomain + "testseries/create-mock",
    createLiveTest: mainDomain + "live-tests/create",
    importLiveTestQuestions: mainDomain + "live-tests/import-questions",
    createBlogs: mainDomain + "blogs/create",
    createNews: mainDomain + "news/create",
    createGallery: mainDomain + "gallery/create",
    createSubscriptionPlan: mainDomain + "api/v2/admin/subscription-plans",
    grantUserSubscription: mainDomain + "api/v2/admin/users/",
    revokeUserSubscription: mainDomain + "api/v2/admin/users/",
    createOverallPurchaseOffer: mainDomain + "api/v2/admin/purchase-offers/overall",
    createUserPurchaseOffer: mainDomain + "api/v2/admin/users/",
    allotquestions: mainDomain + "testseries/allot-question",
    importMockTestSeriesQuestions: mainDomain + "testseries/import-mock-questions",
    createNewNotification: mainDomain + "notifications/create-dash",

    createPopup: mainDomain + "popup/create",
    employerLogin: mainDomain + "admin/login",
    createTestimonial: mainDomain + "testimonial/create",
    jobsList: mainDomain + "emp/jobs/list",
    createNewJob: mainDomain + "emp/jobs/createJob",
    getjobWiseApplicants: mainDomain + "emp/application/list",
    getjobApplicantDetails: mainDomain + "applyCareer/list",
  },
  putUrls: {
    updateSubject: mainDomain + "subject/update/",
    toggleSubjectAr: mainDomain + "subject/toggle-ar/",
    toggleSubjectAgriBoost: mainDomain + "subject/toggle-agriboost/",
    updateExam: mainDomain + "exam/update/",
    updateExamList: mainDomain + "api/v2/admin/pyq/exam-lists/update/",
    updateExamListSet: mainDomain + "api/v2/admin/pyq/exam-list-sets/update/",
    updateYear: mainDomain + "year/update/",
    upddateTopic: mainDomain + "topic/update/",
    toggleTopicAr: mainDomain + "topic/toggle-ar/",
    toggleTopicAgriBoost: mainDomain + "topic/toggle-agriboost/",
    updatelevels: mainDomain + "level/update/",
    updateLevelStatus: mainDomain + "level/status/",
    updateArLevel: mainDomain + "ar-level/update/",
    updateQuestion: mainDomain + "question/update/",
    updateArQuestion: mainDomain + "ar-questions/update/",
    updateAgriBoost: mainDomain + "api/v2/admin/agriboost/update/",
    updatePreviousYearQuestion: mainDomain + "api/v2/admin/pyq/previous-year-questions/update/",
    updatePreviousYearDocument: mainDomain + "api/v2/admin/pyq/previous-year-documents/update/",
    updateUserDetails: mainDomain + "users/details-dash/",
    updateUserCallStatus: mainDomain + "users/details-dash/",
    updateWebContactCallStatus: mainDomain + "web-contact/list-dash/",
    updateUniversity: mainDomain + "universities/update/",
    updateEmployee: mainDomain + "employees/update/",
    updateTestSeries: mainDomain + "testseries/update/",
    updateTestSeriesStatus: mainDomain + "testseries/status/",
    updateMockTestSeriesQuestion: mainDomain + "testseries/mock-question/",
    updateLiveTest: mainDomain + "live-tests/update/",
    updateLiveTestStatus: mainDomain + "live-tests/status/",
    updateLiveTestQuestion: mainDomain + "live-tests/question/",
    approveQuestions: mainDomain + "question/approve-reject/",

    popupStatus: mainDomain + "popup/status/",
    updateSupportIssueStatus: mainDomain + "web-contact/support/tickets/list-dash/",
    updateNews: mainDomain + "news/update/",
    updateNewsStatus: mainDomain + "news/status/",
    updateGallery: mainDomain + "gallery/update/",
    updateGalleryStatus: mainDomain + "gallery/status/",
    updateBlogStatus: mainDomain + "blogs/toggle-status/",
    updateBlog: mainDomain + "blogs/update/",
    updateDksCarsBhataparaAttendance:
      mainDomain + "event-registrations/dkscarsbhatapra/attendance/",
    updateAppRuntimeSettings: mainDomain + "dashboard/settings/runtime",
    updateWalletWithdrawalStatus: mainDomain + "dashboard/wallet-withdrawals/status/",
    updateSubscriptionPlan: mainDomain + "api/v2/admin/subscription-plans/",
    updateSubscriptionSettings: mainDomain + "api/v2/admin/subscription-settings",
    updateOverallPurchaseOffer: mainDomain + "api/v2/admin/purchase-offers/overall/",
    updateUserPurchaseOffer: mainDomain + "api/v2/admin/users/",
  },
  deleteUrls: {
    deleteSubscriptionPlan: mainDomain + "api/v2/admin/subscription-plans/",
    deleteSubject: mainDomain + "subject/delete/",
    deleteExam: mainDomain + "exam/delete/",
    deleteExamList: mainDomain + "api/v2/admin/pyq/exam-lists/delete/",
    deleteExamListSet: mainDomain + "api/v2/admin/pyq/exam-list-sets/delete/",
    deleteYear: mainDomain + "year/delete/",
    deleteTopic: mainDomain + "topic/delete/",
    deleteLevel: mainDomain + "level/delete/",
    deleteArLevel: mainDomain + "ar-level/delete/",
    deleteUser: mainDomain + "users/delete/",
    deleteArQuestion: mainDomain + "ar-questions/delete/",
    deleteAgriBoost: mainDomain + "api/v2/admin/agriboost/delete/",
    deletePreviousYearQuestion: mainDomain + "api/v2/admin/pyq/previous-year-questions/delete/",
    deletePreviousYearDocument: mainDomain + "api/v2/admin/pyq/previous-year-documents/delete/",
    deleteUniversity: mainDomain + "universities/delete/",
    deleteEmployee: mainDomain + "employees/delete",
    deleteBlog: mainDomain + "blogs/delete/",
    deleteNews: mainDomain + "news/delete/",
    deleteGallery: mainDomain + "gallery/delete/",
    deleteNotification: mainDomain + "notifications/delete/",
    deleteTestSeries: mainDomain + "testseries/delete/",
    deleteMockTestSeriesQuestion: mainDomain + "testseries/mock-question/",
    deleteLiveTest: mainDomain + "live-tests/delete/",
    deleteLiveTestQuestion: mainDomain + "live-tests/question/",

    deletePopup: mainDomain + "popup/delete/",
    deleteTestimonial: mainDomain + "testimonial/delete/",
  },
};

export default Constants;
